import { useSelector } from 'react-redux'
import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import { selectPlayerSessionId } from '@core/Areas/KambiClient/Store/selectors'
import { useFeature } from '@core/Utils/hooks/useFeature'
import { getKambiShareablePendingTickets } from './helpers/getKambiShareablePendingTickets'

export const useKambiSharePendingTicketsData = () => {
  const isBetLoopSportActive = useFeature('bet-loop-sports')
  const kambiSessionToken = useSelector(selectPlayerSessionId)

  const { isLoading, isFetching, data, isError } = useQuery({
    queryKey: [queryKeys.betLoopSharePendingTickets, 'kambi'],
    queryFn: getKambiShareablePendingTickets,
    staleTime: 0,
    refetchOnMount: 'always',
    enabled: isBetLoopSportActive && !!kambiSessionToken,
  })

  const kambiTickets = data?.data || []
  const isEmptyState = !isLoading && !isFetching && kambiTickets.length === 0

  return {
    kambiTickets,
    isError,
    isLoading: isLoading || isFetching,
    isEmptyState,
  }
}
